import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ListSearch from '../../Components/ListSearch';
import compensationActions from '../../Actions/compensationActions';
import routes from '../../Constants/routes';
import Card from '../../Components/Card/Card';
import { CompensationStatus, CompensationStatusTranslation } from '../../Constants/Compensations/compensationStatus';
import CompensationList from '../../Components/Settings/Compensation/CompensationList';

export default function SettingsCompensationContainer() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const searchPhrase = searchParams.get('search');
    const status = searchParams.get('status');

    const tickets = useSelector(state => state.SettingsReducer.compensationTickets);
    const user = useSelector(state => state.CommonReducer.user);
    const isLoading = useSelector(state => state.CommonReducer.dataLoading.compensations);

    const statusOptions = [
        { value: CompensationStatus.Open, label: CompensationStatusTranslation[CompensationStatus.Open] },
        { value: CompensationStatus.Closed, label: CompensationStatusTranslation[CompensationStatus.Closed] },
        { value: CompensationStatus.ApprovalRequested, label: CompensationStatusTranslation[CompensationStatus.ApprovalRequested] }
    ];

    useEffect(() => {
        if (!searchParams.get('status')) {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('status', CompensationStatus.Open);
            setSearchParams(newParams, { replace: true });
        }
    }, [searchParams]);

    useEffect(() => {
        if (status) {
            const responsibleManager = status == CompensationStatus.ApprovalRequested ? user.vomId : null;
            dispatch(compensationActions.getCompensationTickets({
                searchPhrase,
                status,
                responsibleManager
            }));
        }
    }, [searchPhrase, status]);

    const updateStatus = (status) => setSearchParams(prev => ({ ...Object.fromEntries(prev), status }), { replace: true });
    const updateSearch = (search) => setSearchParams(prev => ({ ...Object.fromEntries(prev), search }), { replace: true });

    const onClick = (ticket) => {
        navigate(routes.settingsCompensationEdit(ticket.id));
    };

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t('settingscompensationcontainer.header')}</Card.Header.Title>
            </Card.Header>
            <Card.Content>
                <div className="d-flex gap-8 align-items-center flex-wrap mb-8">
                    {statusOptions.map(({ value, label }) => (
                        <button key={value} onClick={() => updateStatus(value)} className={`btn btn-sm${status == value ? ' active' : ''}`}>
                            {t(label)}
                        </button>
                    ))}
                </div>
                <ListSearch onSearchClick={(phrase) => updateSearch(phrase)} placeholder={t('settingscompensationcontainer.searchplaceholder')} />
                <CompensationList compensations={tickets} onClick={onClick} isLoading={isLoading} />
            </Card.Content>
        </Card>
    );
}